import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./slices/userSlice";
import productSlice from "./slices/productSlice";
import planSlice from "./slices/planSlice";
import subscriptionSlice from "./slices/subscriptionSlice";

export const store = configureStore({
  reducer: {
    user: userSlice,
    products: productSlice,
    plans: planSlice,
    subscriptions: subscriptionSlice,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {user: UserState, products: ProductState, ...}
export type AppDispatch = typeof store.dispatch;
